import React, { useState, useEffect } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { GetData, SetDone } from "./Components/Services";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import Loading from "../../../Common/Components/Loading";
import { NIL } from "uuid";
import { ToDateJalali } from "../../../Common/Function";
import { TextField } from "@mui/material";

function List() {
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const [filter, setfilter] = useState({});
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);
  const Handler = (pageNumber = 1, data) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, data, filter).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const HandlerDone = data => {
    setstate({ ...state, loading: true });
    SetDone({ ...data }).then(result => {
      Handler();
      setstate({
        loading: false,
        ...state,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | درخواست ها</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "نام",
            key: "userdetails",
            keyName: "fullname",
          },
          {
            title: "نام مجموعه",
            key: "itemdetails",
            keyName: "name",
          },
          {
            title: "مبلغ",
            key: "amount",
            type: "unit",
          },
          {
            title: "وضعیت",
            key: "status",
            type: "enum",
            enum: {
              waiting: "در حال انتظار",
              done: "پرداخت شده",
              reject: "رد درخواست",
            },
          },

          {
            title: "نوع کاربر",
            key: "user_role",
            type: "enum",
            enum: {
              coach: "مربی",
              manager: "مدیر باشگاه",
              user: "کاربر"
            },
          },
          {
            title: "تاریخ ثبت",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="درخواستی ثبت نشده"
        list={state.data && state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data && state.data.current_page}
        header=" لیست درخواست"
        links={[
          {
            html: (
              <div className="row">
                <div className="col-6">
                  <select
                    className="form-control"
                    onChange={e => {
                      setfilter({ ...filter, status: e.target.value });
                    }}
                  >
                    <option value={""}>وضعیت پرداخت</option>
                    <Fragment>
                      <option value={""}>مشاهده همه</option>
                      <option value={"done"}>تمام شده</option>
                      <option value={"waiting"}>در انتظار</option>
                    </Fragment>
                  </select>
                </div>
                <div className="col-6">
                  <select
                    className="form-control"
                    onChange={e => {
                      setfilter({ ...filter, user_role: e.target.value });
                    }}
                  >
                    <option value={""}>نقش کاربر</option>
                    <Fragment>
                      <option value={""}>مشاهده همه</option>
                      <option value={"coach"}> مربی</option>
                      <option value={"manager"}> مدیر</option>
                    </Fragment>
                  </select>
                </div>
              </div>
            ),
            typeLink: "sort",
          },
          {
            function: (selected, role) => {
              setstate({ ...state, modal: { withdraw_id: selected[0], status: "done", role: role } });
            },
            color: "danger",
            size: "col-md-4",
            html: "تایید پس پرداخت",
            type: "go",
            showRole: true,
          },
          {
            function: selected => {
              HandlerDone({ withdraw_id: selected[0], status: "reject" });
            },
            color: "danger",
            size: "col-md-4",
            html: "رد درخواست",
            type: "cancle",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "مالی",
            main: true,
          },
        ]}
      />
      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={state?.modal?.status == "done" ? "ثبت جزئیات واریز" : "جزییات مالی"}
      >
        {state?.modal?.status == "done"
          ? <DoneData data={state.modal} HandlerDone={HandlerDone} />
          : <RenderBankDetails
            data={
              state?.data?.data &&
              state?.data?.data.find(x => {
                return x.id === state.modal
              })
            }
          />
        }
      </CustomModal>
    </Fragment>
  );
}

export default List;

const RenderBankDetails = ({ data }) => {
  if (!data) {
    return (
      <p>اطلاعاتی ثبت نشده</p>
    )
  }
  return (
    <div>
      {data?.payment_data?.bankName &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>اسم بانک</div>
          <div>{data?.payment_data?.bankName}</div>
        </div>
      }
      {data?.bankNumber &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>شماره شبا</div>
          <div>
            <div>{data?.bankNumber}</div>
          </div>
        </div>
      }
      {data?.itemdetails?.name &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>نام مجموعه </div>
          <div>
            <div>{data?.itemdetails?.name}</div>
          </div>
        </div>
      }
      {data?.payment_data?.description &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>توضیحات </div>
          <div>
            <div>{data?.payment_data?.description}</div>
          </div>
        </div>
      }
      {data?.payment_data?.trackingCode &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>کد پیگیری </div>
          <div>
            <div>{data?.payment_data?.trackingCode}</div>
          </div>
        </div>
      }
      {data?.created_at &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>تاریخ ایجاد </div>
          <div>
            <div>{ToDateJalali(data?.created_at)}</div>
          </div>
        </div>
      }
      {data?.updated_at &&
        <div className="d-flex justify-content-between border p-2 my-2">
          <div>تاریخ تایید </div>
          <div>
            <div>{ToDateJalali(data?.updated_at)}</div>
          </div>
        </div>
      }
    </div>
  );
};


const DoneData = ({ data, HandlerDone }) => {
  const [doneData, setDoneData] = useState()
  return (
    <div className="row">
      <div className="col-12">
        <TextField id="outlined-basic" label="کد پیگیری" variant="outlined" className="w-100"
          onChange={e => setDoneData({ ...doneData, trackingCode: e.target.value })} />
      </div>
      <div className="col-12 my-3">
        <TextField id="outlined-basic" label="توضیحات" variant="outlined" className="w-100"
          onChange={e => setDoneData({ ...doneData, description: e.target.value })} />
      </div>

      <div className="col-12 d-flex justify-content-center">
        <button className="btn btn-primary px-5"
          onClick={e => HandlerDone({ ...data, ...doneData })}>
          ثبت
        </button>
      </div>

    </div >
  );
};
